module.exports = __webpack_public_path__ + "static/media/tax-rebate.a311ae34.svg";